<template>
	<!-- A variable price's "**", alone or before text (the floating cart's and the Cart
	     column's note). A button opening the rules' bubble (price_rule_bubble.js,
	     delegated on the document) when there is a rule to show; plain text otherwise,
	     neither focusable nor announced as a control. The "**" stays out of the msgids,
	     as the totals' markers do. -->
	<!-- price_rule_bubble.js owns aria-expanded: it sets it on open and close. -->
	<button
		v-if="rules.length"
		type="button"
		class="price-rule-trigger"
		:class="{ 'price-rule-note': text }"
		aria-haspopup="dialog"
		aria-expanded="false"
		aria-controls="ioi-price-rule-popup"
		:aria-label="text ? null : __('variable price, see rules')"
		:data-price-rule-key="key"
	><sup class="total-note-marker" :aria-hidden="text ? 'true' : null">**</sup><template v-if="text">{{ " " + text }}</template></button>
	<span
		v-else
		class="price-rule-static"
		:class="{ 'price-rule-note': text }"
	><sup class="total-note-marker">**</sup><template v-if="text">{{ " " + text }}</template></span>
</template>

<script setup>
import { new_rules_key, register_rules, unregister_rules } from "./price_rule_bubble";
import { onBeforeUnmount, onMounted, watch } from "vue";

const props = defineProps({
	// [{name, html, lang}]: the rules the bubble shows, each with a text (the server's
	// cleaned rule); empty when there is none to show.
	rules: {
		type: Array,
		default: () => []
	},
	// The note after the "**", translated by the caller; none for the "**" alone.
	text: {
		type: String,
		default: ""
	}
})

// The bubble keeps the rules, under this trigger's own key: the button carries the key
// alone (price_rule_bubble.js). Registered when the trigger is mounted and whenever its
// rules change, forgotten when it is unmounted, which closes a bubble still showing them.
const key = new_rules_key()
onMounted(() => register_rules(key, props.rules))
watch(() => props.rules, (rules) => register_rules(key, rules))
onBeforeUnmount(() => unregister_rules(key))
</script>
